<template>
  <div class="experience">
    <p>
    <span class="title" :class="strongTitle && 'title-strong'">{{ title }}</span></p>
    <p v-if="subtitle">{{ subtitle }} {{suffix}}</p>
    <p><slot></slot></p>
  </div>
</template>

<script>
export default {
  name: 'ExperienceRow',
  props: {
    title: String,
    subtitle: [String, Number],
    suffix: String, 
    strongTitle: Boolean
  }
}
</script>

<style lang="postcss" scoped>
.experience {

  & p {
    margin: 0;
  }

  &:not(:last-child) {
    margin-bottom: var(--spacing-third);
  }
}

.title {
  display: block;
}

.title-strong {
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/ExperienceRow.vue